import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import r from "../../core/Error.js";
import { isBlobProtocol as i } from "../../core/urlUtils.js";
import { property as t } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as s } from "../../core/accessorSupport/decorators/writer.js";
import { readLoadable as a } from "../../core/accessorSupport/read.js";
import { willPropertyWrite as n } from "../../core/accessorSupport/write.js";
import { supportedTypes as l } from "./operationalLayers.js";
import { opacity as p } from "../support/commonProperties.js";

var y = function y(_y2) {
  var u = /*#__PURE__*/function (_y) {
    _inherits(u, _y);

    var _super = _createSuper(u);

    function u() {
      var _this;

      _classCallCheck(this, u);

      _this = _super.apply(this, arguments), _this.title = null;
      return _this;
    }

    _createClass(u, [{
      key: "writeListMode",
      value: function writeListMode(e, r, i, t) {
        (t && "ground" === t.layerContainerType || e && n(this, i, {}, t)) && (r[i] = e);
      }
    }, {
      key: "writeOperationalLayerType",
      value: function writeOperationalLayerType(e, r, i, t) {
        !e || t && "tables" === t.layerContainerType || (r.layerType = e);
      }
    }, {
      key: "writeTitle",
      value: function writeTitle(e, r) {
        r.title = e || "Layer";
      }
    }, {
      key: "read",
      value: function read(e, r) {
        var _this2 = this;

        r && (r.layer = this), a(this, e, function (r) {
          return _get(_getPrototypeOf(u.prototype), "read", _this2).call(_this2, e, r);
        }, r);
      }
    }, {
      key: "write",
      value: function write(e, t) {
        if (null != t && t.origin) {
          var _e = "".concat(t.origin, "/").concat(t.layerContainerType || "operational-layers"),
              _i = l[_e];

          var _s = _i && _i[this.operationalLayerType];

          var o;
          if ("ArcGISTiledElevationServiceLayer" === this.operationalLayerType && "web-scene/operational-layers" === _e && (_s = !1), !_s) return null == (o = t.messages) || o.push(new r("layer:unsupported", "Layers (".concat(this.title, ", ").concat(this.id, ") of type '").concat(this.declaredClass, "' are not supported in the context of '").concat(_e, "'"), {
            layer: this
          })), null;
        }

        var s = _get(_getPrototypeOf(u.prototype), "write", this).call(this, e, _objectSpread(_objectSpread({}, t), {}, {
          layer: this
        })),
            a = !!t && !!t.messages && !!t.messages.filter(function (e) {
          return e instanceof r && "web-document-write:property-required" === e.name;
        }).length;

        var n;
        return i(null == s ? void 0 : s.url) ? (null == t || null == (n = t.messages) || n.push(new r("layer:invalid-url", "Layer (".concat(this.title, ", ").concat(this.id, ") of type '").concat(this.declaredClass, "' using a Blob URL cannot be written to web scenes and web maps"), {
          layer: this
        })), null) : !this.url && a ? null : s;
      }
    }, {
      key: "beforeSave",
      value: function beforeSave() {}
    }]);

    return u;
  }(_y2);

  return e([t({
    type: String,
    json: {
      write: {
        ignoreOrigin: !0
      },
      origins: {
        "web-scene": {
          write: {
            isRequired: !0,
            ignoreOrigin: !0
          }
        },
        "portal-item": {
          write: !1
        }
      }
    }
  })], u.prototype, "id", void 0), e([t({
    json: {
      write: {
        ignoreOrigin: !0
      },
      origins: {
        "web-map": {
          read: !1,
          write: !1
        }
      }
    }
  })], u.prototype, "listMode", void 0), e([s("listMode")], u.prototype, "writeListMode", null), e([t({
    type: String,
    readOnly: !0,
    json: {
      read: !1,
      write: {
        target: "layerType",
        ignoreOrigin: !0
      },
      origins: {
        "portal-item": {
          write: !1
        }
      }
    }
  })], u.prototype, "operationalLayerType", void 0), e([s("operationalLayerType")], u.prototype, "writeOperationalLayerType", null), e([t(p)], u.prototype, "opacity", void 0), e([t({
    type: String,
    json: {
      write: {
        ignoreOrigin: !0,
        writerEnsuresNonNull: !0
      },
      origins: {
        "web-scene": {
          write: {
            isRequired: !0,
            ignoreOrigin: !0,
            writerEnsuresNonNull: !0
          }
        },
        "portal-item": {
          write: !1
        }
      }
    },
    value: "Layer"
  })], u.prototype, "title", void 0), e([s("title")], u.prototype, "writeTitle", null), e([t({
    type: Boolean,
    json: {
      name: "visibility",
      origins: {
        "web-document": {
          name: "visibility",
          default: !0
        },
        "portal-item": {
          name: "visibility",
          read: {
            source: ["visible", "visibility"]
          }
        }
      }
    }
  })], u.prototype, "visible", void 0), u = e([o("esri.layers.mixins.OperationalLayer")], u), u;
};

function u(e) {
  return "operationalLayerType" in e;
}

export { y as OperationalLayer, u as isOperationalLayer };